export class CheckBoxUtils {
    /**
     * Nastaví na element typu CheckBox odpovídající stav podle vstupu
     * @param element Input typu CheckBox
     * @param value Hodnota, která má být zpracována a nastavena
     */
    public static setCheckValue(element: HTMLInputElement, value: any): void {
        switch (value) {
            case true:
            case "true":
            case 1:
                element.setAttribute("value", "true");
                element.indeterminate = false;
                element.checked = true;
                break;

            // checked na unchecked
            case false:
            case "false":
            case 0:
                element.setAttribute("value", "false");
                element.indeterminate = false;
                element.checked = false;
                break;

            default:
                element.setAttribute("value", "");
                element.indeterminate = true;
                break;
        }
    }
}

//GlobalContext.registerType(BooleanUtils);
